<template>
  <v-layout>
      <v-flex>                    
        <v-data-table
        :headers="headers"
        :items="roles"
        sort-by="calories"
        :search="search"
        class="elevation-1"
        >
        <template v-slot:item.condicion="{ item }">  
            <div v-if="item.condicion">
                <span class="blue--text">Activo</span>
                
            </div>
            <div v-else>
                <span class="red--text">Inactivo</span>                
            </div>                  
        </template>
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Roles</v-toolbar-title>
                <v-divider
                    class="mx-4"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>                 
            </v-toolbar>
        </template>         
        <template slot="no-data">
            <v-btn colo="primary" @click="listar">Resetear</v-btn>
        </template>     
        </v-data-table>                        
      </v-flex>
  </v-layout>
</template>


<script>
import axios from 'axios'      
export default {
    data(){
        return{
            roles:[], 
             adModal:false,            
             dialog: false,
                headers: [                         
                { text: 'Nombre', value: 'nombre' },
                { text: 'Descipcion', value: 'descripcion', sortable: false  },
                { text: 'Estado', value: 'condicion', sortable: false  },                                
                ],
                search:'',
                
                
        }
    },
    computed: {        
    },

    watch: {       
    },

    created () {        
        this.listar();
    },
    methods:{        
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Roles/Listar',configuracion).then(function(response){
              //console.log(response);
              me.roles=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },        
    }
}
</script>